module.exports = __webpack_public_path__ + "assets/img/69_313_1.9b18824d.jpg";